import get from 'lodash/get';
import reduce from 'lodash/reduce';
import isEmpty from 'lodash/isEmpty';

import { VARIANTS } from '@jobcase/react_pattern_library/components/Notification';

import entity from './entity';

import { CATEGORIES } from '../../../../utils/constants/siteNotifications';
import { setNotification } from '../../notification/actions';

const TYPES = {
  ...entity.getTypes(),
  GET_UNSEEN_NOTIFICATIONS_COUNT_REQUEST: 'notifications/GET_UNSEEN_NOTIFICATIONS_COUNT_REQUEST',
  GET_UNSEEN_NOTIFICATIONS_COUNT_SUCCESS: 'notifications/GET_UNSEEN_NOTIFICATIONS_COUNT_SUCCESS',
  GET_UNSEEN_NOTIFICATIONS_COUNT_ERROR: 'notifications/GET_UNSEEN_NOTIFICATIONS_COUNT_ERROR',
  MARK_NOTIFICATION_SEEN_REQUEST: 'notifications/MARK_NOTIFICATION_SEEN_REQUEST',
  MARK_NOTIFICATION_SEEN_ERROR: 'notifications/MARK_NOTIFICATION_SEEN_ERROR',
};

const getEmployerNotifications = options => async (dispatch) => {
  dispatch({ type: TYPES.GET_ALL_REQUEST, payload: { page: options.page } });
  try {
    const response = await entity.api.getEmployerNotifications(options);
    const data = get(response, 'data');
    const content = get(data, 'content');
    const notificationsList = reduce(content, (notifications, notification) => ({ ...notifications, [get(notification, 'key')]: notification }), {});
    data.content = notificationsList;
    dispatch({ type: TYPES.GET_ALL_REQUEST_SUCCESS, payload: data });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_ALL_REQUEST_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while loading employer hiring event notifications. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading employer hiring event notifications.', VARIANTS.INFO));
    }
    return null;
  }
};

const getUnseenEmployerNotificationsCount = options => async (dispatch) => {
  dispatch({ type: TYPES.GET_UNSEEN_NOTIFICATIONS_COUNT_REQUEST });
  try {
    const response = await entity.api.getUnseenNotificationsCount(options);
    dispatch({ type: TYPES.GET_UNSEEN_NOTIFICATIONS_COUNT_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_UNSEEN_NOTIFICATIONS_COUNT_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while fetching unseen notifications count. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while fetching unseen notifications count', VARIANTS.INFO));
    }
    return null;
  }
};

const getUnseenNotificationsCountByEmployerId = (id, categories) => async () => {
  const options = {
    object2Key: id,
    categories,
  };
  try {
    const response = await entity.api.getUnseenNotificationsCount(options);
    return response;
  } catch (error) {
    return null;
  }
};

const markEmployerNotificationAsSeen = options => async (dispatch, getState) => {
  dispatch({ type: TYPES.MARK_NOTIFICATION_SEEN_REQUEST });
  try {
    const unseenKeys = get(options, 'notificationKeys');
    const employerId = get(options, 'employerId');
    const body = reduce(unseenKeys, (result, key) => ({
      ...result,
      data: {
        ...result.data,
        [key]: new Date().toJSON(),
      },
    }), {});
    await entity.api.markNotificationAsSeen(body);
    const state = getState();
    const { entities: { notifications: { pagination: { pageNumber, pageSize } } } } = state;
    dispatch(getUnseenEmployerNotificationsCount({ categories: CATEGORIES.EMPLOYER_HIRING_EVENT }));
    dispatch(getEmployerNotifications({
      categories: CATEGORIES.EMPLOYER_HIRING_EVENT,
      object2Key: employerId,
      size: pageNumber * pageSize,
    }));
  } catch (error) {
    dispatch({ type: TYPES.MARK_NOTIFICATION_SEEN_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while marking notification as seen. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while marking notification as seen.', VARIANTS.INFO));
    }
  }
  return null;
};

export {
  TYPES,
  getUnseenEmployerNotificationsCount,
  markEmployerNotificationAsSeen,
  getEmployerNotifications,
  getUnseenNotificationsCountByEmployerId,
};

export default {
  TYPES,
  ...entity.getActions(),
  getUnseenEmployerNotificationsCount,
  markEmployerNotificationAsSeen,
  getEmployerNotifications,
  getUnseenNotificationsCountByEmployerId,
};
